module.exports = __webpack_public_path__ + "media/images/icons/twotone/fund-52ac1dbc5356e8079a174fac31ffe12a.svg";